{
  "WEBHOOKS_SETTINGS": {
    "HEADER": "Configurações do Webhook"
  }
}
